import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=641f679e&scoped=true"
import script from "./indexTwo.vue?vue&type=script&lang=js"
export * from "./indexTwo.vue?vue&type=script&lang=js"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=641f679e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f679e",
  null
  
)

export default component.exports